export interface ServiceConfig {
  id: string;
  name: string;
  priceINR: number; // Price in INR
}

export interface VerticalConfig {
  id: string;
  name: string;
  services: ServiceConfig[];
}

export const verticalsConfig: Record<string, VerticalConfig> = {
  codeit: {
    id: 'codeit',
    name: 'CodeIt Consulting',
    services: [
      { id: 'web-basic', name: 'Basic Web Development', priceINR: 15000 },
      { id: 'web-pro', name: 'Professional Web Development', priceINR: 50000 },
      { id: 'app-dev', name: 'Mobile App Development', priceINR: 80000 },
    ],
  },
  peptides: {
    id: 'peptides',
    name: 'Peptides Knowledge Park',
    services: [
      { id: 'research-basic', name: 'Basic Research Support', priceINR: 10000 },
      { id: 'research-adv', name: 'Advanced Contract Research', priceINR: 45000 },
      { id: 'student-reg', name: 'Student Registration', priceINR: 299 },
      { id: 'faculty-reg', name: 'Faculty Registration', priceINR: 399 },
    ],
  },
  pepcon: {
    id: 'pepcon',
    name: 'Pepcon Events',
    services: [
      { id: 'pepcon-ticket-standard', name: 'Standard Event Pass', priceINR: 5000 },
      { id: 'pepcon-ticket-vip', name: 'VIP Access Pass', priceINR: 12000 },
      { id: 'pepcon-sponsorship', name: 'Corporate Sponsorship', priceINR: 50000 },
    ],
  },
  digigro: {
    id: 'digigro',
    name: 'DigiGro Marketing',
    services: [
      { id: 'seo-basic', name: 'Basic SEO Package', priceINR: 8000 },
      { id: 'social-media', name: 'Social Media Management', priceINR: 12000 },
      { id: 'digital-pro', name: 'Comprehensive Digital Marketing', priceINR: 35000 },
    ],
  },
  evolve: {
    id: 'evolve',
    name: 'Evolve Skill Development',
    services: [
      { id: 'course-it', name: 'Advanced IT Training Program', priceINR: 5000 },
      { id: 'course-leadership', name: 'Corporate Leadership Workshop', priceINR: 15000 },
    ],
  },
};
